<template>
  <Modal :title="$t('recharge.billet.billetInfo')" name="BILLET_INFO_MODAL">
    <template v-slot:body>
      <span class="body-2">
        {{ $t('recharge.paymentInfo.billetCompleteText') }}
      </span>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalBilletInfo',

  components: {
    Modal
  }
}
</script>
